let constants = {
  // Careers / academy API (courses-api)
  // prod: https://u2bi7wchub.execute-api.eu-west-1.amazonaws.com/main
  baseURL: process.env.REACT_APP_API_URL,
  // HQ admin OTP login (customer-api). Must NOT fall back to courses-api.
  // prod: https://guttduzd8i.execute-api.eu-west-1.amazonaws.com/main
  hqApiURL:
    process.env.REACT_APP_HQ_API_URL ||
    process.env.REACT_APP_CUSTOMER_API_URL ||
    (typeof window !== "undefined" &&
    /careers\.qiktruck\.co\.za$/i.test(window.location.hostname)
      ? "https://guttduzd8i.execute-api.eu-west-1.amazonaws.com/main"
      : process.env.REACT_APP_API_URL),
  coursesURL: "https://courses.qiktruck.co.za",
};
export default constants;
